import {Component, OnInit, ViewChild} from '@angular/core';
import {MGiftVoucherPriceCategory} from '../m-gift-voucher-price-category/model/m-gift-voucher-price-category';
import {Observable} from 'rxjs';
import {debounceTime, distinctUntilChanged, map} from 'rxjs/operators';
import {MGiftvoucherPriceCategoryService} from '../m-gift-voucher-price-category/service/m-gift-voucher-price-category.service';
import {MGiftVoucherService} from './service/m-gift-voucher.service';
import {SnotifyService} from 'ng-snotify';
import {MBulkGiftVoucherCustomer} from '../m-gift-voucher-bulk-customer/model/m-bulk-gift-voucher-customer-dto';
import {MBulkGiftVoucherCustomerService} from '../m-gift-voucher-bulk-customer/service/m-gift-voucher-customer.service';
import {RGiftVoucherData} from './model/r-gift-voucher-data';
import {AppSettings} from '../../settings/app-settings';


@Component({
  selector: 'app-gift-voucher',
  templateUrl: './m-gift-voucher.component.html'
})
export class MGiftVoucherComponent implements OnInit {
  private mGiftVoucherPriceCategorys: MGiftVoucherPriceCategory[] = [];
  private mBulkGiftVoucherCustomer: MBulkGiftVoucherCustomer[];
  private filter: string;
  private rGiftVoucherData: RGiftVoucherData;
  private uiMode: string;

  @ViewChild('inputForm') inputForm;

  constructor(private  mGiftvoucherpricecategoryService: MGiftvoucherPriceCategoryService,
              private mBulkGiftVoucherCustomerService: MBulkGiftVoucherCustomerService,
              private mGiftvoucherService: MGiftVoucherService,
              private snotifyService: SnotifyService) {
    this.rGiftVoucherData = new RGiftVoucherData();
  }

  search = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(200),
      distinctUntilChanged(),
      map(term => term === '' ? []
        : this.mGiftVoucherPriceCategorys.filter(v => v.price.toString().toLowerCase().indexOf(term.toLowerCase()) > -1).slice(0, 10))
    );

  formatter = (x: { price: string }) => x.price;

  searchMBulkGiftVoucherCustomer = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(200),
      distinctUntilChanged(),
      map(term => term === '' ? []
        : this.mBulkGiftVoucherCustomer.filter(v => v.name.toLowerCase().indexOf(term.toLowerCase()) > -1).slice(0, 10))
    );

  formatterMBulkGiftVoucherCustomer = (x: { name: string }) => x.name;

  ngOnInit() {
    // this.inputForm = new FormGroup({
    //   'mGiftVoucherPriceCategory': new FormControl(this.mGiftVoucherData.mGiftVoucherPriceCategory, Validators.required),
    //   'qty': new FormControl(this.mGiftVoucherData.qty, [
    //     Validators.required,
    //     Validators.maxLength(4),
    //     Validators.minLength(1),
    //     Validators.min(1),
    //     Validators.max(1000),
    //     forbiddenNameValidator(/bob/i)
    //   ]),
    //   'value': new FormControl(this.mGiftVoucherData.value)
    // });


    this.uiMode = 'IDEAL';
    this.loadMGiftVoucherPriceCategory();
    this.loadMBulkGiftVoucherCustomer();
    this.inputForm.reset();
  }

  sumbmitFormData(): void {
    if (this.inputForm.invalid) {
      this.snotifyService.error('Fill All Input Text', AppSettings.MESSAGE_WARNING, {
        timeout: 2000,
        showProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true
      });
    } else {
      this.snotifyService.confirm('Save ?..', AppSettings.MESSAGE_INFO, {
        timeout: 5000,
        showProgressBar: false,
        closeOnClick: false,
        pauseOnHover: false,
        buttons: [
          {
            text: 'Yes', action: (toast) => {
              this.snotifyService.remove(toast.id);
              this.mGiftvoucherService.save(this.rGiftVoucherData).subscribe((mGiftVoucherData) => {
                this.snotifyService.success('Gift Voucher Save Success!', AppSettings.MESSAGE_SUCCESS, {
                  timeout: 2000,
                  showProgressBar: false,
                  closeOnClick: false,
                  pauseOnHover: true
                });
                this.clearFormData();
              }, (e) => {
                this.snotifyService.error(e.error.message, AppSettings.MESSAGE_ERROR, {
                  timeout: 2000,
                  showProgressBar: false,
                  closeOnClick: false,
                  pauseOnHover: true
                });
              });
            }
          },
          {
            text: 'No', action: (toast) => {
              this.snotifyService.remove(toast.id);
            }, bold: true
          },
        ]
      });
    }
  }

  getGiftVoucherValue(): void {
    if (this.rGiftVoucherData.qty && this.rGiftVoucherData.mGiftVoucherPriceCategory.price) {
      this.rGiftVoucherData.value = this.rGiftVoucherData.mGiftVoucherPriceCategory.price * this.rGiftVoucherData.qty;
    }
  }

  newFormData(): void {
    this.uiMode = 'EDIT';
  }

  clearFormData(): void {
    this.inputForm.reset();
    this.uiMode = 'IDEAL';
    this.loadMGiftVoucherPriceCategory();
    this.loadMBulkGiftVoucherCustomer();
  }

  loadMGiftVoucherPriceCategory(): void {
    this.mGiftvoucherpricecategoryService.findAll().subscribe((mGiftVoucherPriceCategorys) => {
        this.mGiftVoucherPriceCategorys = mGiftVoucherPriceCategorys;
      },
      (e) => {
        this.mGiftVoucherPriceCategorys = [];
      });
  }

  loadMBulkGiftVoucherCustomer(): void {
    this.mBulkGiftVoucherCustomerService.findAll().subscribe((data) => {
      this.mBulkGiftVoucherCustomer = data;
    }, (e) => {
      this.mBulkGiftVoucherCustomer = [];
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/view/master-files/m-gift-voucher/m-gift-voucher.component.ts